import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const VideoCall = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const partnerInfo = location.state?.partnerInfo;

  useEffect(() => {
    if (!partnerInfo) {
      // No partner info, redirect back to chat
      alert('No partner information provided');
      navigate('/chat');
      return;
    }

    console.log('📹 VideoCall: Received partner info:', partnerInfo);
    console.log('👤 Partner ID:', partnerInfo.id);
    console.log('🆔 Match ID:', partnerInfo.matchId);

    // UNIVERSAL FIX: Pass only partner ID via URL
    // SpeedDatingDemo will fetch fresh data from API
    console.log('🌐 Relying on API fetch for match data');
    
    // Navigate with partner parameter only
    const url = `/speed-dating-demo?partner=${partnerInfo.id}`;
    console.log('🚀 VideoCall: Navigating to:', url);
    navigate(url);
  }, [partnerInfo, navigate]);

  // This component just redirects to the modern speed dating session
  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-400 via-pink-500 to-purple-600 flex items-center justify-center">
      <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-white mx-auto mb-4"></div>
        <p className="text-white text-lg">Starting video date...</p>
      </div>
    </div>
  );
};

export default VideoCall;
